/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getEmploymentStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetEmploymentStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getEmploymentStatusByIdIdRegExpTwo)]).optional()
});

export type GetEmploymentStatusById = zod.input<typeof GetEmploymentStatusById>;
export type GetEmploymentStatusByIdOutput = zod.output<typeof GetEmploymentStatusById>;
